import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useTranslate, useDataProvider, Loading } from 'react-admin';
import SelectBoxFilter from '../common/select-box-filter';
import { Box, makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles({
  textContent: {
    fontFamily: 'UniviaPro',
    fontSize: '13px',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.385,
    letterSpacing: '0.13px',
    color: '#88898c',
    marginTop: 8
  }
});

export default function ConfirmDialogRole({ open, handleClose, handleConfirm, contentText, tittle, value, setNewAssignRoleId, roleName, setRoleName }) {
  const classes = useStyles();
  const translate = useTranslate();
  const dataProvider = useDataProvider();
  const [listRole, setListRole] = useState([]);
  const [loading, setLoading] = useState(false);

  const onChangeRole = (value) => {
    setRoleName(value)
    setNewAssignRoleId(value.id)
  }

  const getListRole = () => {
    const pagination = { page: 1, perPage: 0 };
    const sort = { field: 'id', order: 'DESC' };
    setLoading(true)
    dataProvider('GET_LIST', "roles", {
      filter: {
      },
      pagination,
      sort,
    }).then(({ data }) => {
      data.map((item, index) => {
        if (item.id === value.id || item.name === 'Sysadmin') {
          setNewAssignRoleId(item.id)
          data.splice(index, 1)
        }
      })
      setListRole(data);
      setLoading(false)
    }).catch(error => {
      console.error('Get list error:', error);
      setLoading(false)
    });
  }

  useEffect(() => {
    getListRole()
  }, [open])

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title"> {tittle}</DialogTitle>
        {loading ? <Box ><Loading /></Box> :
          <DialogContent>
            <DialogContentText id="alert-dialog-description" style={{ textAlign: 'center' }}>
              {
                <Box>
                  <Typography className={classes.textContent}>{contentText}</Typography>
                  <Typography className={classes.textContent}>{translate(`resources.role.affectedUser`)}</Typography>
                  <Typography className={classes.textContent}>{translate(`resources.role.pleaseAssign`)}</Typography>
                </Box>
              }
            </DialogContentText>
            <Box my={2}>
              <SelectBoxFilter
                data={listRole}
                label={translate(`resources.role.rolename`)}
                value={roleName ? roleName.name : ''}
                onChange={(value) => onChangeRole(value)}
                keyName='name'
                placeholder={translate('resources.role.placeholder')}
              />
            </Box>
          </DialogContent>
        }
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            {translate(`pos.user.cancel`)}
          </Button>
          <Button disabled={!roleName} onClick={handleConfirm} color="primary" autoFocus>
            {translate(`pos.user.ok`)}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
